import { Icon } from '@dixa/lib-shared-habla';
import { Toolbar, ToolbarButton } from 'articleEditor/components/toolbar';
import toolbarStyles from 'articleEditor/components/toolbar/toolbarButton.module.scss';
import { useFloatingLinkEdit } from 'lib-knowledge-document-structure';

import { InterlinkOpenButton } from './interlinkOpenButton';

type InterlinkDetailsProps = {
  editButtonProps: ReturnType<typeof useFloatingLinkEdit>['editButtonProps'];
  unlinkButtonProps: ReturnType<
    typeof useFloatingLinkEdit
  >['unlinkButtonProps'];
};

export const InterlinkDetails = ({
  editButtonProps,
  unlinkButtonProps,
}: InterlinkDetailsProps): JSX.Element => {
  return (
    <Toolbar>
      <ToolbarButton {...editButtonProps} isActive={false}>
        Edit Interlink
      </ToolbarButton>

      <InterlinkOpenButton
        className={toolbarStyles['toolbarButton']}
        rel="noopener noreferrer"
      >
        <Icon
          className={toolbarStyles['toolbarButtonIcon']}
          name="external-link"
        />
      </InterlinkOpenButton>

      <ToolbarButton
        icon="link-slash"
        {...unlinkButtonProps}
        isActive={false}
      />
    </Toolbar>
  );
};
